<template>
    <div>
        <Header backButton></Header>
        <div class="inscription">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <form method="post" @submit="send" class="indexUp">
                <div class="contenu pt-12">
                    <span class="open-book">
                        <p class="text-2xl leading-normal">
                            Pour vos amis, vous répondez au nom de
                            <input
                                class="my-5 w40 mr-4"
                                name="prenom"
                                v-model="prenom"
                                placeholder="prenom"
                                type="text"
                                required
                            >
                            <input
                                class="my-5 w40 mr-1"
                                name="nom"
                                v-model="nom"
                                placeholder="nom"
                                type="text"
                                required
                            >
                        </p>
                    </span>
                    <p class="text-2xl leading-normal">
                        de sexe
                        <select name="sexe" id="sexe" v-model="sexe">
                            <option selected>masculin</option>
                            <option>feminum</option>
                        </select>,
                    </p>
                    <p class="text-2xl leading-normal">
                        né le
                        <input
                            type="date"
                            class="my-5 w60 mr-1"
                            name="naissance"
                            id="naissance"
                            required
                            v-model="naissance"
                        >
                    </p>
                    <p class="text-2xl leading-normal">
                        et habitant à
                        <input
                            class="my-5 w40 mr-1"
                            name="location"
                            v-model="location"
                            placeholder="location"
                            type="text"
                            required
                        >.
                    </p>
                    <p class="text-3xl mb-10 leading-normal">
                        Ils savent aussi que
                        <textarea
                            name="description"
                            id="description"
                            cols="28"
                            rows="6"
                            placeholder="description"
                            v-model="description"
                            required
                        ></textarea>
                    </p>
                </div>
                <Submit></Submit>
            </form>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Submit from "@/components/inputs/Submit.vue";

export default {
    name: "inscription-public",
    components: {
        Header,
        Submit
    },
    data() {
        return {
            prenom: "",
            nom: "",
            sexe: "",
            location: "",
            description: "",
            naissance: "",
            error: null
        };
    },
    computed: {
        userID: {
            get() {
                return this.$store.getters.currentAppData.userID;
            },
            set(value) {
                this.$store.dispatch("storeUser", {
                    user: value
                });
            }
        }
    },
    methods: {
        send(e) {
            e.preventDefault();
            this.axios
                .put("/api/users/" + this.userID + "/inscription/public", {
                    firstName: this.prenom,
                    lastName: this.nom,
                    sexe: this.sexe,
                    naissance: this.naissance,
                    location: this.location,
                    description: this.description
                })
                .then(response => {
                    if (response.status == 200) {
                        this.$router.push("/inscription-picture");
                    }
                })
                .catch(errors => {
                    this.error = errors.data;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.inscription {
    height: 100%;
    margin-top: 60px;

    .logo {
        position: fixed;
        top: -50px;
        left: -65px;
        width: 80%;
        opacity: 0.3;
    }

    .contenu {
        margin: 0 34px;
        text-align: left;
    }
}

.open-book {
    p:first-of-type {
        text-indent: 0;
    }

    p:first-of-type:first-letter {
        float: left;
        font: 700 3em/0.65 "sunshiney", sans-serif;
        padding: 0.15em 0.15em 0 0;
        text-transform: uppercase;
    }
}

.w40 {
    width: 40%;
}
.w60 {
    width: 60%;
}
</style>